import { createFileRoute } from "@tanstack/react-router";
import { faqPageScript, i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { PercentageCalculatorIndex } from "@/tools/percentage-calculator/pages/PercentageCalculatorIndex";

export const Route = createFileRoute("/percentage-calculator/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.pct_hub_meta_title() },
      { name: "description", content: m.pct_hub_meta_description() },
      { property: "og:title", content: m.pct_hub_meta_title() },
      { property: "og:description", content: m.pct_hub_meta_description() },
      ...i18nOgMeta("/percentage-calculator"),
    ],
    links: [...i18nLinks("/percentage-calculator")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.pct_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.pct_tool_name(),
              item: localeUrl(`/percentage-calculator`),
            },
          ],
        }),
      },
      faqPageScript([
        { q: m.pct_hub_faq1_q(), a: m.pct_hub_faq1_a() },
        { q: m.pct_hub_faq2_q(), a: m.pct_hub_faq2_a() },
        { q: m.pct_hub_faq3_q(), a: m.pct_hub_faq3_a() },
        { q: m.pct_hub_faq4_q(), a: m.pct_hub_faq4_a() },
      ]),
    ],
  }),
  component: PercentageCalculatorIndex,
});
